module.exports = __webpack_public_path__ + "img/37.9f700b67.png";